import clsx from "clsx";
import AreaChart from "../AreaChart";
import { SimpleAreaChartProps } from "./SimpleAreaChart.types";
import useSimpleAreaChart from "./hooks/useSimpleAreaChart";

/**
 * This component is used to display an area chart with a simple props interface.
 * If you need more control over the chart, use the AreaChart component instead.
 */
function SimpleAreaChart({ className, ...rest }: SimpleAreaChartProps) {
    const props = useSimpleAreaChart(rest);
    return <AreaChart className={clsx("simple-area-chart", className)} {...props} />;
}

export default SimpleAreaChart;
